import { createReducer, on } from '@ngrx/store';
import {
  addSpecializations,
  loadSpecializationsSuccess,
  removeSpecializations,
  updateSpecializations,
} from './specializations.actions';
import { IDropDownList } from '@interfaces';

export interface SpecializationsState {
  specializations: IDropDownList[];
}

export const initialState: SpecializationsState = {
  specializations: [],
};

export const specializationsReducer = createReducer(
  initialState,
  on(loadSpecializationsSuccess, (state, { specializations }) => ({
    ...state,
    specializations,
  })),
  on(addSpecializations, (state, { specializations }) => ({
    specializations: [...state.specializations, specializations],
  })),
  on(removeSpecializations, (state, { specializationId }) => ({
    ...state,
    specializations: state.specializations.filter((specializations) => specializations.id !== specializationId),
  })),
  on(updateSpecializations, (state, { specializations }) => ({
    ...state,
    specializations: state.specializations.map((item) => {
      if (item.id === specializations.id) {
        return { ...specializations };
      } else {
        return item;
      }
    }),
  })),
);

export function spcializationReducer(state: SpecializationsState | undefined, action: any) {
  return specializationsReducer(state, action);
}
